import PostRequest from "../../services/PostRequest";
export const ZIPCODES_LIST = "ZIPCODES_LIST";

export const DOMAIN_LIST = "DOMAIN_LIST";

export const OFFICEWORKS_STORE_LIST = "OFFICEWORKS_STORE_LIST";

export const setZipCodeList = (data = {}) => {
  return async (dispatch) => {
    try {
      const response = await PostRequest("/zipcodes/get-zipcodes/", data);

      dispatch({
        type: ZIPCODES_LIST,
        value: response,
      });
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const setZipCodeSearch = (search) => {
  return async (dispatch) => {
    try {
      const data = {
        search: search,
      };

      const response = await PostRequest("/zipcodes/search-zipcodes/", data);

      dispatch({
        type: ZIPCODES_LIST,
        value: response,
      });
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const postCodeDomainList = (data = {}) => {
  return async (dispatch) => {
    try {
      const response = await PostRequest("/settings/domains/", data);

      dispatch({
        type: DOMAIN_LIST,
        value: response,
      });
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const fetchOfficeworksStores = () => {
  return async (dispatch) => {
    try {
      const response = await PostRequest("/settings/officeworks/stores/");

      dispatch({
        type: OFFICEWORKS_STORE_LIST,
        value: response,
      });
    } catch (error) {
      console.log(error.message);
    }
  };
};
